// extracted by mini-css-extract-plugin
export default {"melodyVideo":"VK-z","isFullWidth":"WK-z","landingPageVideo":"XK-z","play":"YK-z","iframeVideo":"ZK-z","playHidden":"_K-z","fullwidth":"aL-z"};